/**
 * Shared Calculator Tools for Blogposts
 * This file contains calculator functions for various tools used across blog posts
 */

// Common utility functions
const calculatorTools = {
  // Format dimensions from inches to feet and inches
  formatDimension: function(inches) {
    if (!inches) return '0';
    const feet = Math.floor(inches / 12);
    const remainingInches = Math.round(inches % 12);
    if (feet === 0) return `${remainingInches}"`;
    return remainingInches === 0 ? `${feet}'` : `${feet}' ${remainingInches}"`;
  },
  
  // Create a result row HTML
  createResultRow: function(label, value) {
    return `
      <div class="result-row">
        <span class="result-label">${label}:</span>
        <span class="result-value">${value}</span>
      </div>
    `;
  }
};

/************************
 * CEILING FAN CALCULATOR
 ************************/
const ceilingFanCalculator = {
  init: function() {
    // Add click handler to the calculate button
    const calculateBtn = document.getElementById('fan-calculate-btn');
    if (calculateBtn) {
      calculateBtn.addEventListener('click', this.calculateFanSize);
    }
  },
  
  calculateFanSize: function() {
    // Get input values
    const length = parseFloat(document.getElementById('room-length').value);
    const width = parseFloat(document.getElementById('room-width').value);
    const ceilingHeight = document.getElementById('ceiling-height').value;
    const roomType = document.getElementById('room-type').value;
    
    // Validate inputs
    if (isNaN(length) || isNaN(width) || length <= 0 || width <= 0) {
      alert('Please enter valid room dimensions');
      return;
    }
    
    // Calculate square footage
    const squareFootage = length * width;
    
    // Determine fan size based on square footage
    let fanSize = "";
    let mountType = "";
    let additionalTip = "";
    
    // Fan size logic
    if (squareFootage <= 75) {
      fanSize = "29-36 inches";
    } else if (squareFootage <= 144) {
      fanSize = "36-42 inches";
    } else if (squareFootage <= 225) {
      fanSize = "44-50 inches";
    } else if (squareFootage <= 400) {
      fanSize = "52-60 inches";
    } else {
      fanSize = "60+ inches or consider multiple fans";
      additionalTip = "For rooms this large, consider installing multiple fans for better air circulation.";
    }
    
    // Mount type based on ceiling height
    if (ceilingHeight === "under8") {
      mountType = "Hugger/Flush Mount";
      additionalTip += " Low-profile or hugger fan recommended for your ceiling height.";
    } else if (ceilingHeight === "8to9") {
      mountType = "Standard Mount";
    } else {
      mountType = "Extended Downrod Mount";
      additionalTip += " Use a longer downrod to position the fan 8-9 feet from the floor for optimal airflow.";
    }
    
    // Room-specific recommendations
    if (roomType === "bedroom") {
      additionalTip += " For bedrooms, consider fans with quiet operation and dimming light features.";
    } else if (roomType === "living") {
      additionalTip += " Position the fan over the main seating area for best comfort.";
    } else if (roomType === "kitchen") {
      additionalTip += " Kitchen fans should have easy-to-clean blades as they will collect grease over time.";
    } else if (roomType === "outdoor") {
      additionalTip += " Make sure to select a fan rated for damp or wet locations for outdoor use.";
    }
    
    // Display results
document.getElementById('square-footage').textContent = `Room Size: ${squareFootage} square feet`;
    document.getElementById('fan-size').textContent = `Recommended Fan Size: ${fanSize}`;
    document.getElementById('mount-type').textContent = `Recommended Mount Type: ${mountType}`;
    document.getElementById('additional-tip').textContent = additionalTip.trim();
    document.getElementById('result-box').style.display = 'block';
  }
};

/************************
 * DINING TABLE CALCULATOR
 ************************/
 document.addEventListener('DOMContentLoaded', function() {
      // Get all elements
      const modeButtons = document.querySelectorAll('[data-mode]');
      const calculateBtn = document.getElementById('calculate-btn');
      const calculateCapacityBtn = document.getElementById('calculate-capacity-btn');
      const resultsContainer = document.getElementById('results');
      
      // Mode switching elements
      const findTableInputs = document.getElementById('find-table-inputs');
      const findCapacityInputs = document.getElementById('find-capacity-inputs');
      const findTableInstructions = document.getElementById('find-table-instructions');
      const findCapacityInstructions = document.getElementById('find-capacity-instructions');
      
      // Capacity mode inputs
      const rectangularInputs = document.getElementById('rectangular-inputs');
      const roundInputs = document.getElementById('round-inputs');
      const squareInputs = document.getElementById('square-inputs');
      const ovalInputs = document.getElementById('oval-inputs');
      
      let currentMode = 'find-table';
      let selectedShape = 'rectangular';
      
      // Mode switching
      modeButtons.forEach(button => {
        button.addEventListener('click', function() {
          modeButtons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');
          
          currentMode = this.getAttribute('data-mode');
          
          if (currentMode === 'find-table') {
            findTableInputs.style.display = 'block';
            findCapacityInputs.style.display = 'none';
            findTableInstructions.style.display = 'block';
            findCapacityInstructions.style.display = 'none';
          } else {
            findTableInputs.style.display = 'none';
            findCapacityInputs.style.display = 'block';
            findTableInstructions.style.display = 'none';
            findCapacityInstructions.style.display = 'block';
          }
          
          resultsContainer.style.display = 'none';
        });
      });
      
      // Shape selection for both modes
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('shape-button') && e.target.hasAttribute('data-shape')) {
          const container = e.target.parentElement;
          container.querySelectorAll('.shape-button').forEach(btn => btn.classList.remove('active'));
          e.target.classList.add('active');
          
          selectedShape = e.target.getAttribute('data-shape');
          
          // Update capacity mode inputs based on shape
          if (currentMode === 'find-capacity') {
            updateCapacityInputs();
          }
        }
      });
      
      function updateCapacityInputs() {
        rectangularInputs.style.display = 'none';
        roundInputs.style.display = 'none';
        squareInputs.style.display = 'none';
        ovalInputs.style.display = 'none';
        
        switch(selectedShape) {
          case 'rectangular':
            rectangularInputs.style.display = 'block';
            break;
          case 'round':
            roundInputs.style.display = 'block';
            break;
          case 'square':
            squareInputs.style.display = 'block';
            break;
          case 'oval':
            ovalInputs.style.display = 'block';
            break;
        }
      }
      
      // Calculate button handlers
      calculateBtn.addEventListener('click', function() {
        if (currentMode === 'find-table') {
          calculateTableSize();
        }
      });
      
      calculateCapacityBtn.addEventListener('click', function() {
        if (currentMode === 'find-capacity') {
          calculateSeatingCapacity();
        }
      });
      
      function calculateTableSize() {
        // Get input values
        const roomWidth = parseFloat(document.getElementById('room-width').value);
        const roomLength = parseFloat(document.getElementById('room-length').value);
        const peopleCount = parseInt(document.getElementById('people-count').value);
        
        // Convert room dimensions to inches
        const roomWidthInches = roomWidth * 12;
        const roomLengthInches = roomLength * 12;
        
        // Constants
        const minSpacePerPerson = 24; // inches width per person
        const minClearance = 36; // inches around table
        
        // Max available space after clearance
        const maxWidth = roomWidthInches - (minClearance * 2);
        const maxLength = roomLengthInches - (minClearance * 2);
        
        // Initialize result object
        let result = {
          width: 0,
          length: 0,
          diameter: 0,
          idealCapacity: 0,
          maxCapacity: 0,
          isViable: true,
          message: ''
        };
        
        // Check if room is too small
        if (maxWidth < 30 || maxLength < 30) {
          result.isViable = false;
          result.message = 'Room is too small for a standard dining table with proper clearance.';
        } else {
          // Calculate based on shape
          switch(selectedShape) {
            case 'rectangular':
              calculateRectangular();
              break;
            case 'round':
              calculateRound();
              break;
            case 'square':
              calculateSquare();
              break;
            case 'oval':
              calculateOval();
              break;
          }
        }
        
        // Display results
        displayResults(result, 'table-size');
        
        function calculateRectangular() {
          const minTableWidth = Math.min(maxWidth, 42); // Standard width 36-42"
          const requiredLength = Math.ceil(peopleCount / 2) * minSpacePerPerson;
          
          result.width = minTableWidth;
          result.length = Math.min(maxLength, requiredLength);
          result.idealCapacity = Math.floor(result.length / minSpacePerPerson) * 2;
          result.maxCapacity = Math.floor(result.length / 20) * 2; // Tighter fit
          
          if (result.idealCapacity < peopleCount) {
            result.message = `This room comfortably seats ${result.idealCapacity} people, which is less than your desired ${peopleCount}.`;
          }
        }
        
        function calculateRound() {
          const maxDiameter = Math.min(maxWidth, maxLength);
          const requiredCircumference = peopleCount * minSpacePerPerson;
          const requiredDiameter = requiredCircumference / Math.PI;
          
          result.diameter = Math.min(maxDiameter, requiredDiameter);
          result.idealCapacity = Math.floor((Math.PI * result.diameter) / minSpacePerPerson);
          result.maxCapacity = Math.floor((Math.PI * result.diameter) / 20);
          
          if (result.idealCapacity < peopleCount) {
            result.message = `A round table in this room comfortably seats ${result.idealCapacity} people.`;
          }
        }
        
        function calculateSquare() {
          const maxSide = Math.min(maxWidth, maxLength);
          const idealSide = Math.min(maxSide, peopleCount * minSpacePerPerson / 4);
          
          result.width = result.length = idealSide;
          result.idealCapacity = Math.floor(idealSide / minSpacePerPerson) * 4;
          result.maxCapacity = Math.floor(idealSide / 20) * 4;
          
          if (result.idealCapacity < peopleCount) {
            result.message = `A square table in this room comfortably seats ${result.idealCapacity} people.`;
          }
        }
        
        function calculateOval() {
          const ovalWidth = Math.min(maxWidth, 42);
          const ovalLength = Math.min(maxLength, (peopleCount * minSpacePerPerson) / 1.8);
          
          result.width = ovalWidth;
          result.length = ovalLength;
          result.idealCapacity = Math.floor((2 * ovalLength + Math.PI * ovalWidth) / minSpacePerPerson);
          result.maxCapacity = Math.floor((2 * ovalLength + Math.PI * ovalWidth) / 20);
          
          if (result.idealCapacity < peopleCount) {
            result.message = `An oval table in this room comfortably seats ${result.idealCapacity} people.`;
          }
        }
      }
      
      function calculateSeatingCapacity() {
        let result = {
          width: 0,
          length: 0,
          diameter: 0,
          idealCapacity: 0,
          maxCapacity: 0,
          isViable: true,
          message: ''
        };
        
        const minSpacePerPerson = 24;
        const maxSpacePerPerson = 20; // For maximum capacity
        
        switch(selectedShape) {
          case 'rectangular':
            const length = parseFloat(document.getElementById('table-length').value);
            const width = parseFloat(document.getElementById('table-width').value);
            
            result.length = length;
            result.width = width;
            
            // Calculate based on perimeter minus corners
            const longSideSeats = Math.floor(length / minSpacePerPerson);
            const shortSideSeats = Math.floor((width - 24) / minSpacePerPerson); // Account for corner space
            result.idealCapacity = (longSideSeats * 2) + (shortSideSeats * 2);
            
            const maxLongSideSeats = Math.floor(length / maxSpacePerPerson);
            const maxShortSideSeats = Math.floor((width - 20) / maxSpacePerPerson);
            result.maxCapacity = (maxLongSideSeats * 2) + (maxShortSideSeats * 2);
            break;
            
          case 'round':
            const diameter = parseFloat(document.getElementById('table-diameter').value);
            result.diameter = diameter;
            
            const circumference = Math.PI * diameter;
            result.idealCapacity = Math.floor(circumference / minSpacePerPerson);
            result.maxCapacity = Math.floor(circumference / maxSpacePerPerson);
            break;
            
          case 'square':
            const side = parseFloat(document.getElementById('table-side').value);
            result.width = result.length = side;
            
            const sideSeats = Math.floor(side / minSpacePerPerson);
            result.idealCapacity = sideSeats * 4;
            
            const maxSideSeats = Math.floor(side / maxSpacePerPerson);
            result.maxCapacity = maxSideSeats * 4;
            break;
            
          case 'oval':
            const ovalLength = parseFloat(document.getElementById('oval-length').value);
            const ovalWidth = parseFloat(document.getElementById('oval-width').value);
            
            result.length = ovalLength;
            result.width = ovalWidth;
            
            // Approximate oval perimeter calculation
            const ovalPerimeter = Math.PI * (3 * (ovalLength + ovalWidth) - Math.sqrt((3 * ovalLength + ovalWidth) * (ovalLength + 3 * ovalWidth))) / 2;
            result.idealCapacity = Math.floor(ovalPerimeter / minSpacePerPerson);
            result.maxCapacity = Math.floor(ovalPerimeter / maxSpacePerPerson);
            break;
        }
        
        displayResults(result, 'seating-capacity');
      }
      
      function displayResults(result, mode) {
        const dimensionsContainer = document.getElementById('dimensions-container');
        const tableShape = document.getElementById('table-shape');
        const warningElement = document.getElementById('warning');
        
        // Clear previous results
        dimensionsContainer.innerHTML = '';
        
        if (!result.isViable) {
          // Display error message
          warningElement.textContent = result.message;
          warningElement.style.display = 'block';
          resultsContainer.style.display = 'block';
          tableShape.style.display = 'none';
          return;
        }
        
        // Create dimensions HTML
        let dimensionsHTML = '';
        
        if (mode === 'table-size') {
          if (selectedShape === 'round') {
            dimensionsHTML += createResultRow('Recommended Diameter', formatDimension(result.diameter));
          } else {
            dimensionsHTML += createResultRow('Recommended Width', formatDimension(result.width));
            dimensionsHTML += createResultRow('Recommended Length', formatDimension(result.length));
          }
          dimensionsHTML += createResultRow('Will Comfortably Seat', `${result.idealCapacity} people`);
          dimensionsHTML += createResultRow('Maximum Capacity', `${result.maxCapacity} people`);
        } else {
          if (selectedShape === 'round') {
            dimensionsHTML += createResultRow('Table Diameter', formatDimension(result.diameter));
          } else {
            dimensionsHTML += createResultRow('Table Width', formatDimension(result.width));
            dimensionsHTML += createResultRow('Table Length', formatDimension(result.length));
          }
          dimensionsHTML += createResultRow('Comfortable Seating', `${result.idealCapacity} people`);
          dimensionsHTML += createResultRow('Maximum Seating', `${result.maxCapacity} people`);
        }
        
        // Add to container
        dimensionsContainer.innerHTML = dimensionsHTML;
        
        // Show warning if needed
        if (result.message) {
          warningElement.textContent = result.message;
          warningElement.style.display = 'block';
        } else {
          warningElement.style.display = 'none';
        }
        
        // Update visual representation
        let roomWidthInches, roomLengthInches;
        
        if (mode === 'table-size') {
          roomWidthInches = parseFloat(document.getElementById('room-width').value) * 12;
          roomLengthInches = parseFloat(document.getElementById('room-length').value) * 12;
        } else {
          // For capacity mode, use the table dimensions as the "room"
          roomWidthInches = result.width || result.diameter;
          roomLengthInches = result.length || result.diameter;
        }
        
        // Calculate table visual dimensions (as percentage of container)
        let visualWidth, visualHeight, borderRadius;
        
        switch(selectedShape) {
          case 'round':
            const diameter = result.diameter;
            visualWidth = visualHeight = (diameter / Math.max(roomWidthInches, roomLengthInches) * 80);
            borderRadius = '50%';
            break;
          case 'square':
            visualWidth = visualHeight = (result.width / Math.max(roomWidthInches, roomLengthInches) * 80);
            borderRadius = '0';
            break;
          case 'oval':
            visualWidth = (result.width / roomWidthInches * 80);
            visualHeight = (result.length / roomLengthInches * 80);
            borderRadius = '40%';
            break;
          case 'rectangular':
            visualWidth = (result.width / roomWidthInches * 80);
            visualHeight = (result.length / roomLengthInches * 80);
            borderRadius = '0';
            break;
        }
        
        // Update table visual
        tableShape.style.width = `${Math.min(visualWidth, 80)}%`;
        tableShape.style.height = `${Math.min(visualHeight, 80)}%`;
        tableShape.style.borderRadius = borderRadius;
        tableShape.style.borderColor = '#38a169';
        tableShape.style.backgroundColor = 'rgba(56, 161, 105, 0.2)';
        
        // Add text to table visual
        if (selectedShape === 'round') {
          tableShape.textContent = `${formatDimension(result.diameter)} diameter`;
        } else {
          tableShape.textContent = `${formatDimension(result.width)} × ${formatDimension(result.length)}`;
        }
        
        tableShape.style.display = 'flex';
        resultsContainer.style.display = 'block';
      }
      
      function createResultRow(label, value) {
        return `
          <div class="result-row">
            <span class="result-label">${label}:</span>
            <span class="result-value">${value}</span>
          </div>
        `;
      }
      
      function formatDimension(inches) {
        if (!inches) return '0';
        const feet = Math.floor(inches / 12);
        const remainingInches = Math.round(inches % 12);
        if (feet === 0) return `${remainingInches}"`;
        return remainingInches === 0 ? `${feet}'` : `${feet}' ${remainingInches}"`;
      }
    });







// Initialize all calculators when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Check which calculator is on the page and initialize it
  if (document.getElementById('fan-calculate-btn')) {
    ceilingFanCalculator.init();
  }
  
  if (document.getElementById('table-calculate-btn')) {
    diningTableCalculator.init();
  }
});

let currentUnit = 'feet';
        
function setUnit(unit) {
            currentUnit = unit;
            document.getElementById('feetBtn').classList.toggle('active', unit === 'feet');
            document.getElementById('metersBtn').classList.toggle('active', unit === 'meters');
            
            // Update placeholder and default values based on unit
            const ceilingInput = document.getElementById('ceilingHeight');
            const fanInput = document.getElementById('fanHeight');
            
            if (unit === 'feet') {
                ceilingInput.placeholder = 'Enter ceiling height in feet';
                fanInput.value = '8';
                fanInput.placeholder = '7-9 feet recommended';
            } else {
                ceilingInput.placeholder = 'Enter ceiling height in meters';
                fanInput.value = '2.4';
                fanInput.placeholder = '2.1-2.7 meters recommended';
            }
        }
        
function calculateDownrod() {
    const ceilingHeight = parseFloat(document.getElementById('ceilingHeight').value);
    const fanHeight = parseFloat(document.getElementById('fanHeight').value);
    
    if (!ceilingHeight || !fanHeight) {
        alert('Please enter both ceiling height and fan height from floor.');
        return;
    }
    
    // Convert to feet if needed
    let ceilingFeet = ceilingHeight;
    let fanFeet = fanHeight;
    
    if (currentUnit === 'meters') {
        ceilingFeet = ceilingHeight * 3.28084;
        fanFeet = fanHeight * 3.28084;
    }
    
    // Check safety requirements
    if (fanFeet < 7) {
        alert('Safety Warning: Fan height from floor must be at least 7 feet (2.1 meters) for safety.');
        return;
    }
    
    if (ceilingFeet < fanFeet + 0.67) { // 8 inches minimum clearance
        alert('Safety Warning: Not enough clearance. Fan needs at least 8 inches from ceiling.');
        return;
    }
    
    // Calculate downrod length
    const downrodFeet = ceilingFeet - fanFeet;
    const downrodInches = downrodFeet * 12;
    
    // Display results
    const resultSection = document.getElementById('resultSection');
    const resultValue = document.getElementById('resultValue');
    const resultRecommendation = document.getElementById('resultRecommendation');
    
    resultValue.innerHTML = `${downrodInches.toFixed(1)} inches (${downrodFeet.toFixed(1)} feet)`;
    
    // Provide recommendations based on calculated length
    let recommendation = '';
    if (downrodInches <= 6) {
        recommendation = 'Short downrod recommended. Perfect for low ceilings. Consider flush mount if space is very limited.';
    } else if (downrodInches <= 18) {
        recommendation = 'Standard downrod length. Good for most residential applications with moderate ceiling heights.';
    } else if (downrodInches <= 36) {
        recommendation = 'Long downrod needed. Ideal for high ceilings. Ensure proper support for longer rods.';
    } else {
        recommendation = 'Extra long downrod required. Consider professional installation for safety. May need special reinforcement.';
    }
    
    // Add ceiling height specific advice
    if (ceilingFeet < 8) {
        recommendation += ' Note: Low ceiling - prioritize safety clearance.';
    } else if (ceilingFeet > 12) {
        recommendation += ' Note: High ceiling - consider adjustable downrod for flexibility.';
    }
    
    resultRecommendation.innerHTML = recommendation;
    resultSection.style.display = 'block';
}

// Allow Enter key to calculate
document.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
        calculateDownrod();
    }
});
function calculateHeight() {

      const counterHeight = parseFloat(document.getElementById('counterHeight').value);
      const userHeight = document.getElementById('userHeight').value;
      if (!counterHeight || counterHeight < 20 || counterHeight > 50) {
          alert('Please enter a valid counter height between 20-50 inches');
          return;
      }
      let gap;
      switch(userHeight) {
          case 'short':gap = 12;
              break;
          case 'tall':gap = 10;
              break;
          default:gap = 11;
      }
      const idealHeight = counterHeight - gap;
      const minHeight = counterHeight - 12;
      const maxHeight = counterHeight - 10;
      // Determine stool type
      let stoolType, recommendation;
      if (idealHeight >= 16 && idealHeight <= 18) {
          stoolType = "Dining Height";
          recommendation = "Perfect for dining tables and breakfast nooks";
      } else if (idealHeight >= 24 && idealHeight <= 26) {
          stoolType = "Counter Height";
          recommendation = "Ideal for kitchen islands and breakfast bars";
      } else if (idealHeight >= 28 && idealHeight <= 32) {
          stoolType = "Bar Height";
          recommendation = "Great for home bars and pub tables";
      } else if (idealHeight >= 32 && idealHeight <= 36) {
          stoolType = "Spectator Height";
          recommendation = "Suitable for high counters and commercial bars";
      } else {
          stoolType = "Custom Height";
          recommendation = "Consider adjustable stools for this height";
      }
      const resultHTML = `
          <div class="result-item-text">Ideal Seat Height: <span class="result-highlight-number">${idealHeight}"</span></div>
          <div class="result-item-text">Height Range: <span class="result-highlight-number">${minHeight}" - ${maxHeight}"</span></div>
          <div class="stool-type-recommendation">
              <p class="recommendation-text">Recommended: ${stoolType} Stools</p>
              <p style="margin: 5px 0 0 0; color: #666; font-size: 14px;">${recommendation}</p>
          </div>
      `;
      document.getElementById('heightResultText').innerHTML = resultHTML;
      document.getElementById('heightResults').style.display = 'block';
}
function calculateSpacing() {
      const counterLength = parseFloat(document.getElementById('counterLength').value);
      const stoolWidth = parseFloat(document.getElementById('stoolWidth').value);
      if (!counterLength || counterLength < 24) {
          alert('Please enter a valid counter length (minimum 24 inches)');
          return;
      }            
      if (!stoolWidth || stoolWidth < 12 || stoolWidth > 30) {
          alert('Please enter a valid stool width between 12-30 inches');
          return;
      }           
      // Calculate based on 24-30 inch spacing per stool
      const minSpacing = 24;
      const maxSpacing = 30;           
      const maxStools = Math.floor(counterLength / minSpacing);
      const comfortableStools = Math.floor(counterLength / maxSpacing);          
      // Calculate actual spacing for different stool quantities
      const spacings = [];
      for (let stools = comfortableStools; stools <= maxStools; stools++) {
          if (stools > 0) {
              const spacing = counterLength / stools;
              const clearance = spacing - stoolWidth;
              spacings.push({
                  count: stools,
                  spacing: spacing.toFixed(1),
                  clearance: clearance.toFixed(1),
                  comfort: clearance >= 6 ? 'Comfortable' : clearance >= 4 ? 'Tight' : 'Too Cramped'
              });
          }
      }            
      let resultHTML = `<div class="result-item-text">Counter Length: <span class="result-highlight-number">${counterLength}"</span></div>`;            
      spacings.forEach(option => {
          const comfortClass = option.comfort === 'Comfortable' ? 'result-highlight-number' : 
                             option.comfort === 'Tight' ? 'color: orange' : 'color: red';
          resultHTML += `
              <div class="result-item-text">
                  <strong>${option.count} Stools:</strong> ${option.spacing}" spacing, ${option.clearance}" clearance 
                  <span style="${comfortClass.includes('color') ? comfortClass : `color: #1f1a5e; font-weight: bold`}">(${option.comfort})</span>
              </div>
          `;
      });
      const recommendedCount = spacings.find(s => s.comfort === 'Comfortable')?.count || spacings[0]?.count;
      if (recommendedCount) {
          resultHTML += `
              <div class="stool-type-recommendation">
                  <p class="recommendation-text">Recommended: ${recommendedCount} Stools</p>
                  <p style="margin: 5px 0 0 0; color: #666; font-size: 14px;">Based on comfortable 6"+ clearance between stools</p>
              </div>
          `;
      }       
      document.getElementById('spacingResultText').innerHTML = resultHTML;
      document.getElementById('spacingResults').style.display = 'block';
}
/**
 * 滚动到指定元素的函数
 * @param {string} elementId - 需要滚动到的元素的ID
 */
function scrollToElement(elementId) {
    // 获取目标元素
    const targetElement = document.getElementById(elementId);
    
    if (!targetElement) {
        console.error(`${elementId} not found`);
        return;
    }
    
    // 获取固定导航栏元素
    const stickyHeader = document.querySelector('.cc-header--sticky');
    
    // 计算导航栏高度
    // const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

     // 根据屏幕宽度确定导航栏高度
    const headerHeight = window.innerWidth > 750 ? 77 : 114;

    // 计算目标元素的位置
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
    console.log('elementPosition',elementPosition);
    console.log('offsetPosition',offsetPosition);

    
    // 平滑滚动到目标位置
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
    
    // 为可访问性添加焦点（可选）
    targetElement.setAttribute('tabindex', '-1');
    targetElement.focus();
}

// rug size calculator
(function() {

  var furnitureOptions = {
    living: {
      label: 'Sofa type',
      options: [
        { value: 'standard', text: 'Standard sofa (6–7 ft)' },
        { value: 'large', text: 'Large sofa (8+ ft)' },
        { value: 'sectional', text: 'L-shaped sectional' },
        { value: 'loveseat', text: 'Loveseat / small setup' }
      ]
    },
    bedroom: {
      label: 'Bed size',
      options: [
        { value: 'twin', text: 'Twin (39" × 75")' },
        { value: 'full', text: 'Full / Double (54" × 75")' },
        { value: 'queen', text: 'Queen (60" × 80")' },
        { value: 'king', text: 'King (76" × 80")' }
      ]
    },
    dining: {
      label: 'Table size',
      options: [
        { value: 'four', text: '4-person table' },
        { value: 'six', text: '6-person table' },
        { value: 'eight', text: '8-person table' },
        { value: 'round', text: 'Round table (4–6 seats)' }
      ]
    },
    kitchen: {
      label: 'Layout',
      options: [
        { value: 'sink', text: 'In front of sink' },
        { value: 'galley', text: 'Galley / work area runner' },
        { value: 'hallway', text: 'Hallway runner' },
        { value: 'entry', text: 'Entryway / mudroom' }
      ]
    }
  };

  window.handleRoomTypeChange = function() {
    var roomType = document.getElementById('room-type').value;
    var group = document.getElementById('furniture-group');
    var select = document.getElementById('furniture-type');
    var label = document.getElementById('furniture-label');

    if (!roomType || !furnitureOptions[roomType]) {
      group.style.display = 'none';
      return;
    }

    var config = furnitureOptions[roomType];
    label.textContent = config.label;
    select.innerHTML = '';
    for (var i = 0; i < config.options.length; i++) {
      var opt = document.createElement('option');
      opt.value = config.options[i].value;
      opt.textContent = config.options[i].text;
      select.appendChild(opt);
    }
    group.style.display = 'block';
  };

  window.calculateRugSize = function() {
    var roomType = document.getElementById('room-type').value;
    var length = parseFloat(document.getElementById('room-length').value);
    var width = parseFloat(document.getElementById('room-width').value);
    var furniture = document.getElementById('furniture-type').value;
    var warning = document.getElementById('calc-warning');
    var results = document.getElementById('results');

    warning.style.display = 'none';
    results.style.display = 'none';

    if (!roomType) {
      showWarning('Please select a room type.');
      return;
    }
    if (!length || !width || length < 4 || width < 4) {
      showWarning('Please enter valid room dimensions (minimum 4 ft each).');
      return;
    }

    var rec = getRecommendation(roomType, length, width, furniture);

    document.getElementById('result-best').textContent = rec.best;
    document.getElementById('result-alt').textContent = rec.alt;
    document.getElementById('result-area').textContent = rec.area;
    document.getElementById('result-tip').textContent = rec.tip;
    results.style.display = 'block';

    if (rec.warning) {
      showWarning(rec.warning);
    }
  };

  function showWarning(msg) {
    var el = document.getElementById('calc-warning');
    el.textContent = msg;
    el.style.display = 'block';
  }

  // Standard rug sizes for matching
  var standardRugs = [
    { name: "2' × 3'",   w: 2,   l: 3,   area: 6 },
    { name: "3' × 5'",   w: 3,   l: 5,   area: 15 },
    { name: "4' × 6'",   w: 4,   l: 6,   area: 24 },
    { name: "5' × 7'",   w: 5,   l: 7,   area: 35 },
    { name: "5' × 8'",   w: 5,   l: 8,   area: 40 },
    { name: "6' × 9'",   w: 6,   l: 9,   area: 54 },
    { name: "8' × 10'",  w: 8,   l: 10,  area: 80 },
    { name: "9' × 12'",  w: 9,   l: 12,  area: 108 },
    { name: "10' × 14'", w: 10,  l: 14,  area: 140 },
    { name: "12' × 15'", w: 12,  l: 15,  area: 180 }
  ];

  var runners = [
    { name: "2' × 6' runner",  w: 2,   l: 6 },
    { name: "2.5' × 7' runner", w: 2.5, l: 7 },
    { name: "2.5' × 8' runner", w: 2.5, l: 8 },
    { name: "2.5' × 10' runner", w: 2.5, l: 10 },
    { name: "3' × 10' runner",  w: 3,   l: 10 }
  ];

  function findBestRug(idealW, idealL, minIdx, maxIdx) {
    // Find the smallest standard rug that meets or exceeds ideal dimensions
    minIdx = minIdx || 0;
    maxIdx = maxIdx || standardRugs.length - 1;
    for (var i = minIdx; i <= maxIdx; i++) {
      if (standardRugs[i].w >= idealW && standardRugs[i].l >= idealL) {
        return i;
      }
    }
    return maxIdx;
  }

  function getRecommendation(roomType, roomL, roomW, furniture) {
    // Ensure length >= width
    if (roomW > roomL) { var t = roomL; roomL = roomW; roomW = t; }

    var best, alt, tip, warn;

    if (roomType === 'living') {
      var border = (roomL >= 14) ? 2 : 1.5;
      var idealL = roomL - (border * 2);
      var idealW = roomW - (border * 2);

      var idx;
      if (furniture === 'sectional') {
        // Sectionals need bigger rugs
        idx = findBestRug(Math.max(idealW, 9), Math.max(idealL, 12), 6);
        tip = 'Place the rug so the entire sectional sits on it, with 6–8 inches extending past the arms.';
      } else if (furniture === 'large') {
        idx = findBestRug(Math.max(idealW, 8), Math.max(idealL, 10), 5);
        tip = 'With a large sofa, all front legs should be on the rug. Extend the rug at least 6 inches past the coffee table.';
      } else if (furniture === 'loveseat') {
        idx = findBestRug(idealW, idealL, 3);
        if (idx > 7) idx = 7;
        tip = 'A smaller setup works with a mid-size rug. Keep at least the front legs on the rug.';
      } else {
        idx = findBestRug(Math.max(idealW, 7), Math.max(idealL, 9), 4);
        tip = 'Front legs of the sofa and chairs should sit on the rug. Leave 18 inches of floor between rug and walls.';
      }

      idx = Math.min(idx, standardRugs.length - 1);
      best = standardRugs[idx].name;
      alt = (idx > 0) ? standardRugs[idx - 1].name + ' (budget option)' : '—';
      if (idx < standardRugs.length - 1) {
        alt = standardRugs[idx - 1].name + ' (budget) or ' + standardRugs[idx + 1].name + ' (upgrade)';
      }

      if (roomL < 10 || roomW < 8) {
        warn = 'Your room is on the smaller side. A larger rug will actually make it feel more spacious — avoid going too small.';
      }

    } else if (roomType === 'bedroom') {
      if (furniture === 'king') {
        best = "9' × 12'";
        alt = "8' × 10' (tighter fit, still works)";
        tip = 'Position the rug so it extends 16+ inches on each side of the bed and 2 feet past the foot.';
      } else if (furniture === 'queen') {
        best = "8' × 10'";
        alt = "6' × 9' (smaller rooms) or 9' × 12' (spacious rooms)";
        tip = 'Place the rug so two-thirds extends from under the bed toward the foot. About 18 inches on each side.';
      } else if (furniture === 'full') {
        best = "6' × 9'";
        alt = "8' × 10' (for larger bedrooms)";
        tip = 'Center the rug under the lower two-thirds of the bed with even exposure on both sides.';
      } else {
        best = "5' × 8'";
        alt = "4' × 6' (very small room) or 6' × 9'";
        tip = 'For a twin bed, you can also use a 2.5\' × 8\' runner on the stepping-out side.';
      }

      if (roomL < 10 && (furniture === 'king' || furniture === 'queen')) {
        warn = 'Your room may be tight for a ' + (furniture === 'king' ? 'king' : 'queen') + ' bed plus a full rug. Consider bedside runners as an alternative.';
      }

    } else if (roomType === 'dining') {
      if (furniture === 'eight') {
        best = "9' × 12'";
        alt = "10' × 14' (extra chair room)";
        tip = 'The rug should extend at least 24 inches past the table on all sides so chairs stay on the rug when pulled out.';
      } else if (furniture === 'six') {
        best = "8' × 10'";
        alt = "9' × 12' (more comfortable for guests)";
        tip = 'Add 24 inches to each side of the table. Chairs at the ends need room to slide back fully.';
      } else if (furniture === 'round') {
        // Round table logic
        var tableD = 4; // assume 48" round table
        var rugD = tableD + 4; // +24" each side
        best = rugD + "' round rug (8' diameter)";
        alt = "6' round (tight) or 10' round (generous)";
        tip = 'Add 24 inches beyond the table edge on all sides. A round rug echoes the table shape for a cohesive look.';
      } else {
        best = "6' × 9'";
        alt = "8' × 10' (if space allows)";
        tip = 'Even a small table needs 24 inches of rug clearance on each side for comfortable chair movement.';
      }

      if (roomW < 10 && (furniture === 'eight' || furniture === 'six')) {
        warn = 'Your dining room is narrow. Make sure there\'s at least 36 inches between the rug edge and the wall for walkway space.';
      }

    } else if (roomType === 'kitchen') {
      if (furniture === 'sink') {
        best = "2' × 3'";
        alt = "3' × 5' (wider coverage)";
        tip = 'Place directly in front of the sink. A washable rug is highly recommended for this spot.';
      } else if (furniture === 'galley') {
        var runnerL = Math.min(roomL - 1, 10);
        var runnerMatch = runners[0].name;
        for (var i = runners.length - 1; i >= 0; i--) {
          if (runners[i].l <= runnerL + 1) {
            runnerMatch = runners[i].name;
            break;
          }
        }
        best = runnerMatch;
        alt = "2' × 3' at sink + separate runner along counter";
        tip = 'Leave 4–6 inches of floor on each side of the runner. Choose washable material for easy cleanup.';
      } else if (furniture === 'hallway') {
        var hallL = Math.max(roomL, roomW);
        var hallRunner = runners[0].name;
        for (var i = runners.length - 1; i >= 0; i--) {
          if (runners[i].l <= hallL - 1) {
            hallRunner = runners[i].name;
            break;
          }
        }
        best = hallRunner;
        alt = 'One size up or down depending on hallway length';
        tip = 'The runner should stop 6 inches before any doorway. Leave a few inches of floor on each side.';
      } else {
        best = "3' × 5'";
        alt = "2' × 3' (compact entry)";
        tip = 'Entry rugs take heavy foot traffic. Look for low-pile, easy-clean materials that can handle shoes and moisture.';
      }
    }

    // Calculate area for the best recommendation
    var areaStr = '—';
    for (var i = 0; i < standardRugs.length; i++) {
      if (best && best.indexOf(standardRugs[i].name) !== -1) {
        areaStr = standardRugs[i].area + ' sq ft';
        break;
      }
    }
    // Handle runners
    if (areaStr === '—') {
      for (var i = 0; i < runners.length; i++) {
        if (best && best.indexOf(runners[i].name) !== -1) {
          areaStr = (runners[i].w * runners[i].l) + ' sq ft';
          break;
        }
      }
    }
    // Handle round rugs and small rugs
    if (areaStr === '—' && best) {
      if (best.indexOf("2' × 3'") !== -1) areaStr = '6 sq ft';
      else if (best.indexOf("3' × 5'") !== -1) areaStr = '15 sq ft';
      else if (best.indexOf("round") !== -1) areaStr = '~50 sq ft';
    }

    return {
      best: best || '—',
      alt: alt || '—',
      area: areaStr,
      tip: tip || '',
      warning: warn || null
    };
  }

})();


